<script setup lang="ts">
import type { IConversationModel } from '@tencentcloud/chat-uikit-engine';
import { TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import { message } from 'ant-design-vue';
import { sendMessages, sendTyping } from '../utils/sendMessage';
import MessageInputEditor from './message-input-editor.vue';
import MessageInputQuote from './message-input-quote/index.vue';
import MessageInputButton from './message-input-button.vue';
import type { ITipTapEditorContent } from '@/TUIKit/interface';
import { isSensitiveWords } from '@/views/session/sensitive-words';

const props = defineProps({
    placeholder: {
        type: String,
        default: '输入内容后回车键(Enter键)发送'
    },
    muteText: {
        type: String,
        default: ''
    }
});

const emit = defineEmits(['sendMessage', 'resetReplyOrReference', 'onTyping']);
const editor = ref<InstanceType<typeof MessageInputEditor>>();
const currentConversation = ref<IConversationModel>();

TUIStore.watch(StoreName.CONV, {
    currentConversation: (conversation: IConversationModel) => {
        currentConversation.value = conversation;
    }
});

const onTyping = (inputContentEmpty: boolean, inputBlur: boolean) => {
    sendTyping(inputContentEmpty, inputBlur);
};

async function validateMessage(messageList: ITipTapEditorContent[]) {
    return new Promise((resolve, reject) => {
        console.log(messageList, 'messageList');
        for (const content of messageList) {
            if (content.type === 'text') {
                const textMessageContent = JSON.parse(JSON.stringify(content?.payload?.text));

                const sensitiveWord = isSensitiveWords(textMessageContent);
                if (sensitiveWord) {
                    message.error(`检测到输入中含有违规词“${sensitiveWord}”，禁止发送`);
                    reject(`检测到输入中含有违规词“${sensitiveWord}”，禁止发送`);
                }
            }
        }
        resolve(true);
    });
}

const sendMessage = async () => {
    const editorContentList = editor.value?.getEditorContent();
    if (!editorContentList || !currentConversation.value) return;

    await validateMessage(editorContentList);
    if (!editorContentList?.length) return;
    await sendMessages(editorContentList, currentConversation.value);
    emit('sendMessage');
    editor.value?.resetEditor();
};

const insertEmoji = (emoji: any) => {
    editor.value?.addEmoji(emoji);
};

const reEdit = (content: any) => {
    editor.value?.resetEditor();
    // resetReplyOrReference();
    editor.value?.setEditorContent(content);
};

defineExpose({
    insertEmoji,
    reEdit
});
</script>

<template>
    <div class="message-input-wrapper">
        <div :class="['message-input-container']">
            <MessageInputEditor
                ref="editor"
                :placeholder="props.placeholder"
                :is-muted="false"
                @send-message="sendMessage"
                @on-typing="onTyping"
            />

            <MessageInputButton @send-message="sendMessage" />
        </div>

        <!-- 引用消息 -->
        <MessageInputQuote />
    </div>
</template>

<style scoped lang="scss">
.message-input-wrapper {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.message-input-container {
    position: relative;
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
    border: none;
    overflow: hidden;
}
</style>
